import React from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import UISpinner from 'Components/UIComponents/UISpinner';

interface HeaderButtonProps {
  title?: string;
  icon: string;
  iconType?: 'stroke' | 'fill';
  onClick: () => Promise<void> | void;
  disabled?: boolean;
  isLoading?: boolean;
  isMobile?: boolean;
}

const HeaderButton = ({
  title,
  icon,
  onClick,
  isLoading = false,
  disabled = false,
  iconType = 'stroke',
  isMobile,
}: HeaderButtonProps) => {
  return (
    <button
      disabled={disabled}
      className={classNames(
        'documentPreview__document-header-button',
        `documentPreview__document-header-button--${iconType}`,
        { mobile: isMobile },
      )}
      onClick={onClick}
    >
      {isLoading && (
        <UISpinner wrapperClassName="spinner__wrapper spinner__wrapper--overlay spinner__wrapper--full-cover spinner__wrapper--bg-gray spinner__wrapper--rounded" />
      )}
      <ReactSVG src={icon} className="documentPreview__document-header-button-icon" />
      {title}
    </button>
  );
};

export default HeaderButton;
